import { CustomerOrderContext } from "../../../../contexts/customerOrder.context";

export const handleCount = (type, setFunction, count) => {
  if (type === "negative" && count > 0) {
    setFunction(count - 1);
  } else if (type === "positive") {
    setFunction(count + 1);
  }
};
export const handleClick = (subsectionClass, setSubclass) => {
  if (subsectionClass === "chm-subsection-hidden") {
    setSubclass("chm-subsection-visible");
  } else if (subsectionClass === "chm-subsection-visible") {
    setSubclass("chm-subsection-hidden");
  }
};
export const addOrderItem = (
  count,
  orderContext,
  setOrderContext,
  itemName,
  itemDetails
) => {
  if (count !== 0) {
    var tempItemTotal = count * itemDetails["price"];
    var tempOrderItem = {
      itemCount: count,
      itemTotal: tempItemTotal,
    };
    setOrderContext({ ...orderContext, [itemName]: tempOrderItem });
  } else {
    var newObject = {};
    Object.keys(orderContext).map((index) => {
      if (index !== itemName) {
        newObject = { ...newObject, [index]: orderContext[index] };
      }
    });
    setOrderContext(newObject);
  }
};
